import React from 'react';

// WORKFLOW-333 this has to remain
import { getJobStatus } from '../../../globals';
import { JobStatusBadge } from '../../common/job-status-badge';

interface IActivityPropertyJobStatus {
  value?: string | null;
}

// ActivityProperty JobStatus = 8
export const ActivityPropertyJobStatus = ({
  value,
}: IActivityPropertyJobStatus) => {
  if (value === null || value === undefined || value === '') {
    return null;
  }

  const parsedVal = parseInt(value, 10);
  if (isNaN(parsedVal)) {
    // we tried, not a number, not much more we can do
    return null;
  }

  // WORKFLOW-333 this has to remain - old activity entries will have the old status in them
  return <JobStatusBadge status={getJobStatus(parsedVal)} />;
};
